import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGlobeCrossedOut = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(1.2504 1.2504)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M21.2803 20.2197L20.2197 21.2803L17.7998 18.8604C15.9126 20.502 13.4482 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 8.05172 0.996992 5.58642 2.63867 3.69922L0.219727 1.28027L1.28027 0.219727L21.2803 20.2197ZM1.5332 11.5C1.86803 15.6714 4.9676 19.0597 9 19.832C7.20966 17.4173 6.16711 14.5189 6.01855 11.5H1.5332ZM14.6631 15.7236C14.1571 17.1898 13.43 18.5764 12.499 19.832C14.096 19.5265 15.5458 18.8112 16.7373 17.7979L14.6631 15.7236ZM7.52051 11.5C7.68363 14.4881 8.81791 17.3415 10.749 19.626C12.0136 18.1302 12.9364 16.3912 13.4688 14.5293L10.4395 11.5H7.52051ZM10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 12.3593 21.1461 13.8881 20.5107 15.2607L19.8301 14.9453L19.1494 14.6309C19.6952 13.4517 20 12.1374 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5C9.3014 1.5 7.93269 1.83272 6.71387 2.4248L6.38574 1.75L6.05859 1.0752C7.47715 0.386137 9.06954 0 10.75 0ZM3.70117 4.76172C2.4801 6.19745 1.69288 8.00927 1.5332 10H6.02051C6.06335 9.12941 6.17822 8.26865 6.36621 7.42676L3.70117 4.76172ZM7.65234 8.71289C7.58862 9.13824 7.54509 9.56769 7.52148 10H8.93945L7.65234 8.71289Z",
			fill: "currentColor"
		})
	})
});
export default SvgGlobeCrossedOut;
